if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',
    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          enabled: 'mobile-sticky-bar-enabled',
          isShow: 'mobile-sticky-bar-up',
          isHide: 'mobile-sticky-bar-down',
        };

        this.compareToggleUnsubscriber = FoxTheme.pubsub.subscribe('compare:toggle', this.onCompareToggle.bind(this));
      }

      compareToggleUnsubscriber = undefined;

      connectedCallback() {
        document.body.classList.add(this.classes.enabled);
        if (this.isCompareBarShowing()) {
          this.hide();
        } else {
          this.show();
        }

        /*Original code removed by Zeus Start
        this.lastScrollTop = 0;
        this.scrollHandler = FoxTheme.utils.debounce(this.onScrollHandler.bind(this), 10);
        this.init();
        Original code removed by Zeus End*/
        this.calculateHeight();
        /*Custom code added by Zeus Start*/
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
        /*Custom code added by Zeus End*/
        /*Custom code added by Zeus Start*/
        this.links = this.querySelectorAll('.mobile-sticky-bar__link');
        if (this.links.length) {
          this.links[0].classList.add('active');
          this.links.forEach((link) => {
            link.addEventListener('click', () => {
              this.links.forEach((l) => l.classList.remove('active'));
              link.classList.add('active');
            });
          });
        }
        /*Custom code added by Zeus End*/
      }

      disconnectedCallback() {
        /*Original code removed by Zeus Start
        window.removeEventListener('scroll', this.scrollHandler);
        Original code removed by Zeus End*/

        if (this.compareToggleUnsubscriber) {
          this.compareToggleUnsubscriber();
        }
        /*Custom code added by Zeus Start*/
        this.removeEventListener('click', this.onClick);
        /*Custom code added by Zeus End*/
      }

      /*Custom code added by Zeus Start*/
      onClick(event) {
        const searchTrigger = event.target.closest('.mobile-sticky-bar__search');
        if (!searchTrigger) return;
        event.preventDefault();

        const searchInput = document.querySelector('header input[type="search"]');
        if (searchInput) {
          searchInput.focus();
          searchInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
        } else {
          window.location.href = (FoxTheme.routes && FoxTheme.routes.search_url) || '/search';
        }
      }
      /*Custom code added by Zeus End*/

      /*Original code removed by Zeus Start
      init() {
        this.calculateHeight();
        window.addEventListener('scroll', this.scrollHandler, false);
      }
      Original code removed by Zeus End*/

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }

      isCompareBarShowing() {
        return document.body.classList.contains('is-product-comparing');
      }

      onCompareToggle(event) {
        if (event.isActive) {
          this.hide();
        } else {
          this.show();
        }
      }
      
      /*Original code removed by Zeus Start
      onScrollHandler() {
        if (this.isCompareBarShowing()) {
          this.hide();
          return;
        }

        const offsetTop = document.getElementById('mobileNavStatic').offsetTop;
        const scrollTop = window.scrollY;
        const pointTouch = offsetTop - scrollTop - window.innerHeight;

        requestAnimationFrame(() => {
          this.scrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'up';
          this.lastScrollTop = scrollTop;

          if (this.scrollDirection == 'up' && pointTouch > 0) {
            this.show();
          } else {
            this.hide();
          }
        });
      }
      Original code removed by Zeus End*/

      show() {
        document.body.classList.remove(this.classes.isHide);
        document.body.classList.add(this.classes.isShow);
      }

      hide() {
        document.body.classList.remove(this.classes.isShow);
        document.body.classList.add(this.classes.isHide);
      }
    }
  );
}
/*Custom code added by Zeus for Glow.AI Mobile Dock Widget Start*/
(function () {
  const bar = document.querySelector('mobile-sticky-bar');
  if (!bar) return;
  const trigger = bar.querySelector('[data-glowai-toggle]');
  if (!trigger) return;

  const setOpen = (open) => {
    bar.classList.toggle('glowai-open', open);
    document.body.classList.toggle('glowai-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    setOpen(!bar.classList.contains('glowai-open'));
  });

  document.addEventListener('click', (e) => {
    if (!bar.classList.contains('glowai-open')) return;
    if (e.target.closest('[data-glowai-toggle]')) return;  
    setOpen(false);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && bar.classList.contains('glowai-open')) setOpen(false);
  });
})();
/*Custom code added by Zeus for Glow.AI Mobile Dock Widget End*/

/*Custom code added by Zeus for Sub-Collections Drawer Start*/
(function () {
  if (customElements.get('sub-collections-drawer')) return;
  class SubCollectionsDrawer extends HTMLElement {
    constructor() {
      super();
      this._onKey = this._onKey.bind(this);
    }
    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-tab-index]');
      this.panes = this.querySelectorAll('[data-pane-index]');
      this.tabs.forEach((btn) => btn.addEventListener('click', () => this.selectTab(btn.dataset.tabIndex)));
      this.querySelectorAll('[data-sub-collections-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
    }
    open() {
      const header = document.querySelector('header');
      if (header) {
        document.documentElement.style.setProperty(
          '--header-bottom-position',
          parseInt(header.getBoundingClientRect().bottom) + 'px'
        );
      }
      document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.body.classList.add('sub-collections-open');
      document.addEventListener('keydown', this._onKey);
      const trigger = document.querySelector('[aria-controls="' + this.id + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('sub-collections-open');
      document.removeEventListener('keydown', this._onKey);
      const trigger = document.querySelector('[aria-controls="' + this.id + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      setTimeout(() => { this.hidden = true; }, 260);
    }
    selectTab(index) {
      this.tabs.forEach((btn) => {
        const active = btn.dataset.tabIndex === String(index);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panes.forEach((pane) => {
        pane.classList.toggle('is-active', pane.dataset.paneIndex === String(index));
      });
      const content = this.querySelector('.sub-collections-drawer__content');
      if (content) content.scrollTop = 0;
    }
    _onKey(e) {
      if (e.key === 'Escape') this.close();
    }
  }
  customElements.define('sub-collections-drawer', SubCollectionsDrawer);

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-sub-collections-toggle]');
    if (!trigger) return;
    const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!drawer) return;
    e.preventDefault();
    if (drawer.classList.contains('is-open')) drawer.close();
    else drawer.open();
  });
})();
(function () {
  document.addEventListener('pointerdown', (e) => {
    const drawer = document.querySelector('sub-collections-drawer.is-open');
    if (!drawer) return;

    // Ignore taps inside the drawer panel itself
    if (e.target.closest('.sub-collections-drawer__panel')) return;

    // Ignore the drawer's own toggle triggers — let them handle their own close
    if (e.target.closest('[data-sub-collections-toggle]')) return;
    if (e.target.closest('[aria-controls^="SubCollectionsDrawer"]')) return;

    drawer.close();
  }, true);
})();
/*Custom code added by Zeus for Sub-Collections Drawer End*/